import React, { useState } from 'react';
import { Box, Typography, Link, Container } from '@mui/material';
import { Email } from '@mui/icons-material';
import PDFViewerModal from '../Application/PDFViewerModal';

const Footer: React.FC = () => {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showCodeOfConduct, setShowCodeOfConduct] = useState(false);

  // PDF paths in public folder
  const termsOfServicePDF = '/Full_Applicant_Terms.pdf';
  const privacyNoticePDF = '/Privacy_and_Data_Notice.pdf';
  const codeOfConductPDF = '/Code_of_Conduct.pdf';

  return (
    <Box
      component="footer"
      sx={{
        mt: 'auto',
        py: 3,
        px: 2,
        backgroundColor: (theme) => theme.palette.grey[100],
        borderTop: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 3,
            flexWrap: 'wrap'
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Email fontSize="small" color="action" />
            <Typography variant="body2" color="text.secondary">
              Need help?{' '}
              <Link
                href="mailto:help@mentoringfusion.com"
                color="primary"
                sx={{
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                Contact support
              </Link>
            </Typography>
          </Box>
          
          <Typography variant="body2" color="text.secondary">
            <Link
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowTerms(true);
              }}
              color="primary"
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Terms & Conditions
            </Link>
          </Typography>

          <Typography variant="body2" color="text.secondary">
            <Link
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowPrivacy(true);
              }}
              color="primary"
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Privacy & Data Notice
            </Link>
          </Typography>

          <Typography variant="body2" color="text.secondary">
            <Link
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowCodeOfConduct(true);
              }}
              color="primary"
              sx={{
                textDecoration: 'none',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            >
              Code of Conduct
            </Link>
          </Typography>
        </Box>
      </Container>
      
      {/* Full Terms Modal */}
      <PDFViewerModal
        open={showTerms}
        onClose={() => setShowTerms(false)}
        title="Terms & Conditions"
        pdfPath={termsOfServicePDF}
      />
      
      {/* Full Privacy Modal */}
      <PDFViewerModal
        open={showPrivacy}
        onClose={() => setShowPrivacy(false)}
        title="Privacy & Data Notice"
        pdfPath={privacyNoticePDF}
      />
      
      {/* Full Code of Conduct Modal */}
      <PDFViewerModal
        open={showCodeOfConduct}
        onClose={() => setShowCodeOfConduct(false)}
        title="Code of Conduct"
        pdfPath={codeOfConductPDF}
      />
    </Box>
  );
};

export default Footer;
